import { Box, Button, Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import InvoicePreviewModal from '../invoiceTemplate/InvoicePreviewModal';

const sampleInvoice = {
  invoiceNo: "INV-2026-0001",
  date: "June 26, 2026",
  auctionName: "Mid Year Auction",

  customerCode: "CUST-001",
  customerName: "Juan Dela Cruz",
  customerAddress: "Makati City",
  email: "juan@email.com",

  hammerTotal: 300000,
  buyersPremium: 60000,
  vat: 7200,
  grandTotal: 367200,

  items: [
    {
      lotNumber: 4,
      artist: "Artist A",
      artworkTitle: "Artwork A",
      hammerPrice: 80000,
      premium: 16000,
      total: 96000
    },
 ]
}






const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    overflow: "hidden",
    borderRadius: 12,
    border: "1px solid #e5e7eb",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    background: "#fff",
  },

  container: {
    maxHeight: 600,
  },

  tableHead: {
    background: "#f8f9fb",
  },

  headerCell: {
    fontWeight: 600,
    fontSize: 14,
    color: "#222",
    background: "#f8f9fb",
    borderBottom: "1px solid #e5e7eb",
  },

  bodyCell: {
    fontSize: 14,
    color: "#444",
    borderBottom: "1px solid #f1f3f4",
    paddingTop: 14,
    paddingBottom: 14,
  },

  row: {
    transition: "background .2s",

    "&:hover": {
      background: "#fafafa",
    },
  },

  pagination: {
    borderTop: "1px solid #e5e7eb",
  },
}));
export default function PreviewStep({ data }) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openPreview, setOpenPreview] = React.useState(false);
  const [selectedInvoice, setSelectedInvoice] = React.useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

    return (
         <div>
       <div style={{
                border: '1px solid #e0e0e0',
                borderRadius: '6px',
                padding: '20px',
                background: '#fafafa',
                marginBottom:"25px"
            }}>
                <Box>
                <Typography variant="h5" style={{ fontWeight: 'bold', color: '#000' }}>
                   2. Preview Data
                </Typography>
                <Typography variant="body2" style={{ color: '#555' ,marginTop:"5px"}}>
                   Please review the data below. You can go back to replace the file if needed
                </Typography>
                </Box>  



                <div>
                         <Paper className={classes.root}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader aria-label="sticky table">
                                <TableHead className={classes.tableHead}>
                                    <TableRow>
                                   
                                        <TableCell>
                                            Email
                                        </TableCell>
                                         <TableCell>
                                            Name
                                        </TableCell>
                                         <TableCell>
                                            Lot
                                        </TableCell>
                                         <TableCell>
                                            Total
                                        </TableCell>
                                         <TableCell>
                                            Action
                                        </TableCell>
                                    </TableRow>

                                    </TableHead>
                                     <TableBody>
                                    {data.map((row,index) => (
                                        <TableRow
                                            hover
                                            className={classes.row}
                                            key={index}
                                        >
                                          <TableCell
                                              
                                                className={classes.bodyCell}
                                          >
                                                 {row['email']}
                                          </TableCell>
                                       
                                            <TableCell
                                              
                                                className={classes.bodyCell}
                                          >
                                                 {row['customerName']}
                                          </TableCell>
                                           <TableCell
                                              
                                                className={classes.bodyCell}
                                          >
                                           


                                                {Array.isArray(row.lotNumber)
                                                    ? row.lotNumber.join(", ")
                                                    : row.lotNumber}
                                          </TableCell>
                                            <TableCell
                                              
                                                className={classes.bodyCell}
                                                align='right'
                                          >
                                                 {row['hammerPrice'].toFixed(2)}
                                          </TableCell>
                                        <TableCell
                                                className={classes.bodyCell}
                                                align="center"
                                                >
                                                <Button
                                                variant="contained"
                                                color="primary"
                                               onClick={() => {
                                                    setSelectedInvoice(sampleInvoice);
                                                    setOpenPreview(true);
                                                }}
                                                >
                                                        Preview
                                                </Button>
                                                </TableCell>
                                        </TableRow>


                                        
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                className={classes.pagination}
                                rowsPerPageOptions={[10, 25, 100]}
                                component="div"
                                count={data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                          </Paper>

                </div>
        </div>
        <InvoicePreviewModal
  open={openPreview}
  invoice={selectedInvoice}
  onClose={() => setOpenPreview(false)}
/>
    </div>
    )

}
